import { Phone, MessageCircle, FileText } from "lucide-react";
import { useQuote } from "./Header";
import { SITE } from "../../lib/config";
import { track } from "../../lib/analytics";

export default function MobileStickyCTA() {
  const openQuote = useQuote();
  const waHref = `https://wa.me/${SITE.whatsapp}?text=${encodeURIComponent(
    "Hi Chennai Packs, I'd like a quote for your packaging products."
  )}`;
  const telHref = `tel:+${SITE.phoneRaw}`;

  return (
    <nav
      data-testid="mobile-sticky-cta"
      aria-label="Contact Chennai Packs"
      className="sm:hidden fixed inset-x-0 bottom-0 z-40 bg-white/95 backdrop-blur border-t border-[#E2E8E4] shadow-[0_-6px_24px_-8px_rgba(10,28,14,0.15)] pb-[env(safe-area-inset-bottom)]"
    >
      <div className="grid grid-cols-3 divide-x divide-[#E2E8E4]">
        <a
          href={telHref}
          onClick={() => track("Mobile CTA Call")}
          data-testid="mobile-cta-call"
          className="flex flex-col items-center justify-center gap-1 py-2.5 text-[#0A1C0E] active:bg-[#F8FAF8]"
        >
          <Phone size={20} className="text-[#1D6B2A]" />
          <span className="text-[11px] font-semibold">Call</span>
        </a>
        <a
          href={waHref}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => track("Mobile CTA WhatsApp")}
          data-testid="mobile-cta-whatsapp"
          className="flex flex-col items-center justify-center gap-1 py-2.5 text-white bg-[#25D366] active:opacity-90"
        >
          <MessageCircle size={20} className="fill-white" />
          <span className="text-[11px] font-semibold">WhatsApp</span>
        </a>
        <button
          onClick={() => { track("Mobile CTA Get Quote"); openQuote(); }}
          data-testid="mobile-cta-quote"
          className="flex flex-col items-center justify-center gap-1 py-2.5 text-white bg-[#1D6B2A] active:opacity-90"
        >
          <FileText size={20} />
          <span className="text-[11px] font-semibold">Get a Quote</span>
        </button>
      </div>
    </nav>
  );
}
